/**
 * Shared logic for the "Bulk Change Students Level" action (ELL-7746 follow-up ticket).
 * Kept pure so it's cheap to unit test, mirroring the pattern used by levelControl.ts.
 */

/** System level ids, matching the existing `levelName_1`..`levelName_5` catalog. */
export const BULK_LEVEL_CHANGE_LEVEL_IDS = [1, 2, 3, 4, 5] as const;

/**
 * ELL-7734's bulk-change-level endpoint expects `newLevel` as a `LEVEL_1`..`LEVEL_5` enum
 * string, not the plain numeric id used by the single-student edit path.
 */
export const getLevelApiValue = (levelId: number): string => `LEVEL_${levelId}`;
